/**
 * Предоставляет доступ к карточкам категорий и операции фильтрации по ним.
 */
export class CategoriesData {
  private container: HTMLElement
  private categories: HTMLElement[]

  /**
   * Создаёт источник данных категорий на основе DOM-контейнера.
   * @param {HTMLElement} container Контейнер со списком карточек категорий.
   */
  constructor(container: HTMLElement) {
    this.container = container
    this.categories = Array.from(
      this.container.querySelectorAll<HTMLElement>('.category-card')
    )
  }

  /**
   * Возвращает полный список найденных карточек категорий.
   * @return {HTMLElement[]} Массив элементов карточек категорий.
   */
  public getCategories(): HTMLElement[] {
    return this.categories
  }

  /**
   * Фильтрует категории по тексту поиска из атрибута `data-title`.
   * @param {string} searchTerm Поисковая строка.
   * @return {HTMLElement[]} Массив категорий, заголовок которых содержит поисковую строку.
   */
  public getFilteredCategories(searchTerm: string): HTMLElement[] {
    const lowerSearchTerm = searchTerm.toLowerCase()
    return this.categories.filter((category) => {
      const titleText = category.dataset.title || ''
      return titleText.toLowerCase().includes(lowerSearchTerm)
    })
  }
}
